import React, { useRef, useState } from "react";
import { BiLinkExternal, BiMenu, BiTargetLock } from "react-icons/bi";
import "./LinkedMaps.css";
import { Popup } from "@progress/kendo-react-popup";
import { BiX } from "react-icons/bi";

const MapMenu = ({
    mapName,
    setActiveMaps,
    activeMaps,
    setActiveWindows,
    activeWindows,
    centerMap,
}) => {
    const menuAnchor = useRef();
    const [menuOpen, setMenuOpen] = useState();

    const handlePopup = () => {
        setMenuOpen(!menuOpen);
    };

    const handleClose = () => {
        const newActiveMaps = { ...activeMaps };
        newActiveMaps[mapName] = false;
        setActiveMaps(newActiveMaps);
    };

    const handleOpenWindow = () => {
        const newActiveWindows = { ...activeWindows };
        newActiveWindows[mapName] = true;
        console.log(newActiveWindows);
        setActiveWindows(newActiveWindows);
    };

    return (
        <>
            <div className="linked-map-options" ref={menuAnchor} onClick={handlePopup}>
                <BiMenu size={20} />
            </div>
            <Popup
                anchor={menuAnchor.current}
                show={menuOpen}
                popupClass={"select-maps-popup"}
                popupAlign={{ horizontal: "right", vertical: "top" }}
                anchorAlign={{ horizontal: "right", vertical: "bottom" }}>
                <div className={"options-list"}>
                    <BiX title={"Close View"} onClick={handleClose} />
                    <BiTargetLock title={"Center Map"} onClick={centerMap} />
                    <BiLinkExternal title={"Popout Window"} onClick={handleOpenWindow} />
                </div>
            </Popup>
        </>
    );
};

export default MapMenu;
